import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#6EB800",
    "col2n": "#000000"
}
function FacEye042({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M10.75 5.25q0-2.15-1.6-3.7Q7.55-.05 5.4 0 3.15-.05 1.55 1.55 0 3.1 0 5.25q0 2.15 1.55 3.7 1.6 1.55 3.85 1.6 2.15-.05 3.75-1.6t1.6-3.7z"
                    id="FacEye042__Symbol_86_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M5.8 5.65q1-.95 1-2.35 0-1.35-1-2.35-.9-.9-2.2-.9-.1-.05-.15 0Q2 0 1 .95q-1 1-1 2.35 0 1.4 1 2.35 1 1 2.45 1.05.05-.05.15 0 1.3-.1 2.2-1.05z"
                    id="FacEye042__Symbol_87_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#FacEye042__Symbol_86_0_Layer0_0_FILL"
                transform="translate(203.1 161.55)"
                id="FacEye042__col1n"
            />
            <use
                xlinkHref="#FacEye042__Symbol_87_0_Layer0_0_FILL"
                transform="translate(204.95 163.4)"
                id="FacEye042__col2n"
            />
        </g></g>
    )
}
export default FacEye042
